// 个人简历数据

// 动态计算年龄与工作年限（1992年出生，2015年参加工作）
const birthYear = 1992
const workStartYear = 2015
const now = new Date()
const currentYear = now.getFullYear()

const calcAge = () => {
  // 精确到生日（假设下半年，按年差近似，简历场景足够）
  return currentYear - birthYear
}
const calcWorkYears = () => {
  return currentYear - workStartYear
}

export const resume = {
  name: '余静',
  alias: '细雨若静',
  title: '安卓开发工程师 / Java 开发工程师',
  intro: `${calcWorkYears()} 年 Android 与 Java 开发经验，擅长移动端架构设计与软硬件交互。中国烟草西南大区 Android 设备全流程开发与实施，20+ 项目落地并长期运维（部分项目从 2016 年持续维护至今）。横跨 ESP32 固件、微信小程序、后端服务的全栈能力。开源工具 YUtils、YSerialPort、YHttp、kotlinx 原创作者。`,
  location: '四川省成都市龙泉驿区',
  age: `${calcAge()}岁`,
  workYears: `${calcWorkYears()}年`,
  phone: '18780662752',
  email: 'yu1441@qq.com',
  qq: '3373217',
  weibo: '细雨若静',
  avatar: '',

  // 技能矩阵（按分类，含掌握程度）
  skillGroups: [
    {
      group: '移动端开发',
      icon: 'fa-solid fa-mobile-screen',
      skills: [
        { name: 'Android 原生', level: 95 },
        { name: 'Kotlin', level: 92 },
        { name: 'Java', level: 93 },
        { name: 'Jetpack / DataBinding / ViewBinding', level: 88 },
        { name: 'RxJava / RxBus 响应式', level: 90 }
      ]
    },
    {
      group: '硬件与通信',
      icon: 'fa-solid fa-microchip',
      skills: [
        { name: '串口通信 (yserialport)', level: 95 },
        { name: 'NFC / CPU卡 / M1卡', level: 90 },
        { name: '蓝牙 BLE / BLE 电子秤', level: 86 },
        { name: 'USB 摄像头 / UVC 双目', level: 88 },
        { name: '人脸识别 / 活体检测', level: 82 },
        { name: 'RFID / 电子秤 / 打印机 / LED', level: 90 }
      ]
    },
    {
      group: '网络与通信',
      icon: 'fa-solid fa-network-wired',
      skills: [
        { name: 'WebSocket 实时通信', level: 90 },
        { name: 'MQTT 物联网协议', level: 86 },
        { name: 'Socket 长连接 / UDP', level: 88 },
        { name: 'HTTP / HTTPS (OkHttp)', level: 92 },
        { name: 'SOAP 协议 (ksoap2)', level: 85 }
      ]
    },
    {
      group: '后端与全栈',
      icon: 'fa-solid fa-server',
      skills: [
        { name: 'Spring Boot', level: 82 },
        { name: 'MyBatis-Plus / MySQL', level: 84 },
        { name: 'Redis / Session', level: 80 },
        { name: '微信小程序 (原生 + Vant)', level: 86 },
        { name: 'Vue / Web 前端', level: 78 }
      ]
    },
    {
      group: '底层与进阶',
      icon: 'fa-solid fa-code',
      skills: [
        { name: 'JNI / NDK / C', level: 82 },
        { name: '自定义 View / UI', level: 88 },
        { name: '多线程 / 线程池', level: 88 },
        { name: 'TTS 语音 / 海康 SDK', level: 86 },
        { name: 'ESP32 / Arduino / PlatformIO', level: 78 }
      ]
    }
  ],

  // 关键特质标签
  traits: ['架构设计', '软硬件协同', '开源贡献', '技术攻坚', '长期运维', '全栈能力', '责任心强', '团队协作', '快速学习', '稳定可靠'],

  // 工作经历
  experiences: [
    {
      time: `2015.12 — 至今（${calcWorkYears()}年+）`,
      company: '成都慧能信息技术有限公司 · 开发部',
      role: '安卓工程师 / 移动端负责人',
      duties: [
        '公司移动端负责人，主导安卓 App 全流程开发：需求确定、原型评审、架构选型、开发语言确定、通信协议定义、API 定义与代码实现。',
        '底层 SDK 开发与工具类沉淀，制定并执行底层约束规范，保障多项目复用与稳定性。开源 yutils / yserialport / yuvc / kotlinx 工具库。',
        '全程参与中国烟草西南大区所有 Android 设备与软件的开发及实施，累计完成 20+ 项目，部分项目从 2016 年持续维护至今。',
        '横跨 ESP32 固件开发、微信小程序开发、Spring Boot 后端服务，覆盖物联网回收、烟叶收购仓储全链路。'
      ]
    }
  ],

  // 项目经验（真实项目，按业务线分组）
  portfolioProjects: [
    {
      time: '2022 — 至今',
      name: '凉山/攀枝花新磅码设备',
      role: '主要开发 / 长期运维',
      tags: ['Kotlin', '串口', '海康SDK', 'RFID', '电子秤', 'LED'],
      desc: '2022 年新一代烟叶磅码设备，替代 2019 老定级设备。完整业务流程：烟农刷卡→排号校验→呼叫→读 RFID 等级牌定级→读电子秤磅码归零校验→刷卡确认→结束交售。整合海康威视视频、LED 显示屏、RFID 等级牌、电子秤多硬件。',
      env: 'Kotlin · 串口(yserialport) · 海康 HCNetSDK · EasyFloat 悬浮窗',
      tech: '海康威视 so 集成、串口电子秤控制、RFID 等级牌读取、LED 显示屏推送、悬浮窗辅助、凉山/攀枝花双渠道 productFlavors'
    },
    {
      time: '2019 — 至今',
      name: '凉山烟叶仓储管理二检',
      role: '主要开发 / 长期运维',
      tags: ['Kotlin', 'SOAP', '扫码枪', '安全软键盘', '7年运维'],
      desc: '凉山老二检系统，版本 4.0.8，持续维护 7 年。覆盖排号、交接、调拨出库、移入移出库、库存查询、包装管理、改密等 10+ 模块。doc 下沉淀 17 个 puml 时序图与流程图，README 含极详细二检数据结构与接口说明。',
      env: 'Kotlin · ksoap2-android SOAP · ScannerAPI 扫码枪 · 安全软键盘',
      tech: 'SOAP 协议对接老系统、扫码枪采集、zxing 二维码、DialogX、多屏幕适配 values-sw320~960dp、凉山州渠道'
    },
    {
      time: '2024 — 至今',
      name: '米易仓储二检',
      role: '主要开发',
      tags: ['Kotlin', 'WebSocket', '扫码枪', '安全软键盘'],
      desc: '米易（攀枝花）新仓储二检系统，liangshan_erjian 的升级版。从 SOAP 协议升级到 WebSocket+OkHttp 实时通信，扫码枪 ScannerAPI 采集，安全软键盘，版本 1.4.7。',
      env: 'Kotlin · Java-WebSocket · OkHttp 5 · ScannerAPI',
      tech: 'WebSocket 实时通信替代 SOAP、扫码枪、zxing、PickView、Glide、MultiDex、攀枝花渠道'
    },
    {
      time: '2025 — 至今',
      name: '凉山州排号设备人脸识别版',
      role: '主要开发',
      tags: ['Kotlin', '人脸识别', '双目摄像头', '身份证', '活体检测'],
      desc: '2025 年最新排号设备。集成双目摄像头活体检测、inspireface 离线人脸识别与对比、身份证/银行卡读取、烟农照片同步、排号打印小票。支持银行卡绑定开关、ANR 监控。',
      env: 'Kotlin · inspireface · yuvc · Camera2/CameraX · utilcodex',
      tech: 'inspireface 离线人脸识别、活体检测、双目 UVC 摄像头、身份证+银行卡双读、anrwatchdog ANR 抓取'
    },
    {
      time: '2023 — 至今',
      name: '大卫智能物联网回收后端',
      role: '后端开发',
      tags: ['Spring Boot', 'MQTT', 'Redis', '微信支付', 'OTA'],
      desc: '垃圾分类/智能回收生态统一后台，对接微信小程序、Android APP、智能回收设备、自助售卖/兑换机、饮水机。涵盖回收订单、设备控制、积分商城、押金体系、加盟商结算、OTA 升级、电围栏。',
      env: 'Spring Boot 2.4.13 · Java 8 · MyBatis-Plus · MySQL · Redis',
      tech: 'Eclipse Paho MQTT v3（command 1-307）、weixin-java-mp/pay、Shiro、SocketIO、Druid、腾讯云/阿里云短信、OTA 远程升级'
    },
    {
      time: '2023 — 至今',
      name: '大卫智能垃圾分类 Android 端',
      role: '主要开发',
      tags: ['Kotlin', 'MQTT', '腾讯地图', '视频监控', 'Markdown'],
      desc: '「大卫智能」Android 客户端（清运人员/管理端），与 smart-david 后端、小程序协同。MQTT 控制回收设备（开门/出货/清理），腾讯地图定位清运路线，ArtPlayer 视频监控，Markwon 渲染评价规则。',
      env: 'Kotlin+Java · compileSdk 35 · MQTT(paho) · 腾讯地图 · ArtPlayer',
      tech: 'MQTT 设备控制、腾讯地图定位+矢量SDK+组件库、ArtPlayer 视频、MPAndroidChart、Markwon Markdown、java17 编译'
    },
    {
      time: '2023 — 至今',
      name: '大卫智能用户端小程序',
      role: '主要开发',
      tags: ['微信小程序', 'Vant', '蓝牙称重', '积分商城', '100+页面'],
      desc: '「大卫智能」用户端入口，覆盖智能回收（投递/上门）、积分商城、设备租赁（净水器/滤芯）、环保社区、押金缴纳提现。100+ 页面，三 Tab（商城/回收/我的），蓝牙称重采集。',
      env: '原生小程序 · Vant Weapp 1.6.6 · WeUI · live-player 插件',
      tech: '原生 MINA、Vant Weapp、routePlan 路线规划、live-player 直播、MQTT over WSS、蓝牙称重、自定义 TabBar、隐私合规'
    },
    {
      time: '2025',
      name: 'ESP32-C3 蓝牙电子秤固件',
      role: '固件开发',
      tags: ['ESP32', 'Arduino', 'BLE', 'HX711', '低功耗'],
      desc: '基于 ESP32-C3 + HX711 称重传感器的 BLE 电子秤固件，配合「大卫智能」APP 使用。蓝牙 AT 指令（AT+WEIGHT/AT+BD/AT+ZERO/AT+BATVOLT）提供称重、标定、归零、电池电量、电压校准。150kg 量程 128 增益，深度睡眠+GPIO 唤醒低功耗设计。',
      env: 'PlatformIO + Arduino · HX711 · BLEDevice/BLEServer · Preferences(NVS)',
      tech: 'BLE AT 指令集、HX711 称重、100kΩ+38.3kΩ 分压测电池电压、深度睡眠、GPIO 唤醒、断连自动休眠'
    },
    {
      time: '2019 — 至今',
      name: '烟叶收购查询打印终端',
      role: '主要开发 / 长期运维',
      tags: ['Kotlin', '得实打印机', '串口', '读卡器', '7年运维'],
      desc: '部署在收购点的查询终端，提供公告/政策展示、烟农信息、合同信息、凭证查询、交售等级汇总、交售历史/计划查询及凭证打印。版本 1.11，持续维护 7 年。',
      env: 'Kotlin+Java8 · 得实 dascom 打印机 SDK · ZM703 读卡器',
      tech: '串口(yserialport)、ZM703 读卡器、RxBus 总线、Gson、Glide、Bugly、音频语音播报、凉山/攀枝花双渠道'
    },
    {
      time: '2019',
      name: '烟叶交烟刷卡设备',
      role: '主要开发',
      tags: ['Java', 'UVC摄像头', 'H.264推流', 'M1卡', '读卡器'],
      desc: '磅码页面核心设备，刷卡确认交售。集成 UVC/网络摄像头实时视频推送（H.264）、呼叫队列、烟农信息、磅码定级数据展示、语音播报、M1 卡解析。双摄像头驱动可切换。',
      env: 'Java8 · UVC + OpenCV · ZM703 读卡器 · 串口打印机',
      tech: 'UVC 摄像头驱动、网络摄像头 H.264 推流、M1 卡解析、刷卡采集烟农照片、SQLite 本地库、RxJava/RxBus'
    },
    {
      time: '2021',
      name: '烟叶收购监控看板',
      role: '主要开发',
      tags: ['Kotlin', '海康威视', 'HCNetSDK', '大屏看板'],
      desc: '收购现场监控大屏看板，集成海康威视 HCNetSDK/PlayerSDK 实现实时视频监控，32 位 only，开启 multidex。',
      env: 'Kotlin · 海康 HCNetSDK.jar + PlayerSDK.jar + jna.jar',
      tech: '海康威视 SDK 集成、实时视频监控、multiDex、armeabi 32 位'
    },
    {
      time: '2019 — 至今',
      name: '烟点扫码终端',
      role: '主要开发 / 长期运维',
      tags: ['Kotlin', 'Kotlin DSL', 'Java 21', '扫码枪', 'PDA'],
      desc: '烟叶收购前在烟点扫码登记烟包的终端，兼容优博讯 PDA。协议含设备登录、工作人员登录、基础数据下载、批次申请、单批次统计、上传烟包、结束扫码、删除烟包、绑定车牌号等接口。',
      env: 'Kotlin · build.gradle.kts (Kotlin DSL) · Java 21 · ScannerAPI',
      tech: 'Kotlin DSL 构建、Java 21、扫码枪、OkHttp 5、zxing、DialogX、PickerView、凉山/攀枝花渠道'
    },
    {
      time: '2022 前后',
      name: '烟农预检预约 APP',
      role: '主要开发',
      tags: ['Kotlin', 'NFC', '日历控件', '烘烤记录'],
      desc: '烟农预检预约 APP，版本 2.5。NFC 读取烟农卡，日历控件预约，烟点轮次信息展示，预约超次数限制，烘烤记录查看。',
      env: 'Kotlin · NFC(ynfc1.4.jar) · calendarview · MultiDex',
      tech: 'NFC 烟农卡读取、日历预约、烟点轮次限制、Glide、Toasty、materialtabstrip'
    },
    {
      time: '2024',
      name: '米易仓储磅重 PDA 互联版',
      role: '主要开发',
      tags: ['Kotlin', 'WebSocket', 'PDA互联', '二维码'],
      desc: '米易版仓储磅重，版本 1.2.2。相比凉山版增加 WebSocket 服务端/客户端、PDA 互联、二维码扫码、手动扣减/等级/水分录入。',
      env: 'Kotlin · Java-WebSocket 1.6.0 · OkHttp 5 · zxing',
      tech: 'WebSocket 实时通信、PDA 互联、二维码扣减、BaseRecyclerViewAdapterHelper4、DialogX'
    },
    {
      time: '2026',
      name: '就用它 · 实用工具箱小程序',
      role: '独立开发',
      tags: ['微信小程序', '113个工具', 'Vant', 'Canvas', '传感器'],
      desc: '面向程序员和普通用户的工具箱小程序，分日常(47)/开发(36)/查询(10)/效率(20)四大类共 113 个工具。纯客户端运行无后端，4 个子包分包加载，含计算器、格式化、编码解码、二维码、速查表、番茄钟、指南针、水平仪等。',
      env: '原生 MINA · Vant Weapp 1.11.7 · jsqr · qrcode-generator · Canvas 2D',
      tech: '工具注册表机制、本地存储收藏/最近使用、传感器（指南针/水平仪）、jpeg-js/upng-js 图片处理、工具元信息检索'
    }
  ],

  // 教育背景
  education: {
    time: '2010.09 — 2014.07',
    school: '宜宾学院',
    major: '计算机科学与技术（本科）',
    courses: 'C++、Java、数据结构、数据库概论、数据库应用、数字逻辑、汇编语言、高等数学、线性代数、离散数学、Windows 环境编程实践、操作系统、计算方法、J2EE、计算机网络、Linux 操作系统、计算机图形学、编译原理、微机接口技术'
  },

  // 自我评价
  selfAssessment: '性格稳重，对软件开发怀有浓厚兴趣与热情。工作认真负责，具有强烈责任心；为人真诚，善于沟通协作。始终保持学习态度，积极应对变化。擅长 Java / Kotlin 开发，具备良好的软件分析、设计、开发与应用能力。拥有出色的学习能力和团队合作精神，能迅速适应新工作环境。',

  // 联系方式卡片
  contacts: [
    { label: 'GitHub', value: 'github.com/yutils', icon: 'fa-brands fa-github', url: 'https://github.com/yutils' },
    { label: 'Gitee', value: 'gitee.com/yos', icon: 'fa-brands fa-git-alt', url: 'https://gitee.com/yos' },
    { label: 'CSDN', value: 'blog.csdn.net/Yu1441', icon: 'fa-brands fa-blogger-b', url: 'https://blog.csdn.net/Yu1441' },
    { label: '微博', value: '细雨若静', icon: 'fa-brands fa-weibo', url: 'https://weibo.com/32005200' },
    { label: 'QQ', value: '3373217', icon: 'fa-brands fa-qq', url: 'tencent://message/?uin=3373217&Site=&Menu-=yes' },
    { label: '邮箱', value: 'yu1441@qq.com', icon: 'fa-solid fa-envelope', url: 'mailto:yu1441@qq.com' }
  ]
}

// 项目统计（用于简历页头部数字展示）
export const projectStats = [
  { value: 20, label: 'Android 项目', suffix: '+' },
  { value: 4, label: 'ESP32 固件', suffix: '' },
  { value: 3, label: '微信小程序', suffix: '' },
  { value: 4, label: '后端服务', suffix: '' }
]
